<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            name="period"
            type="year"
            :range="true"
            label="게시년도"
            defaultStart="-3y"
            defaultEnd="0y"
            v-model="period"
          ></c-datepicker>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="ESF 경영방침 목록"
      :columns="grid.columns"
      :gridHeight="grid.height"
      :data="grid.data"
      rowKey="policyId"
      :columnSetting="false"
      :expandAll="true"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn v-if="editable" label="등록" icon="add" @btnClicked="bookPopup" />
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'saf-hea-manage-policy',
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:150px',
            sortable: true,
          },
          {
            name: 'policyYear',
            field: 'policyYear',
            label: '게시년도',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
          {
            name: 'policyTitle',
            field: 'policyTitle',
            label: '제목',
            align: 'left',
            type: "link",
            sortable: true,
          },
          {
            name: 'policyDate',
            field: 'policyDate',
            label: '게시일자',
            align: 'center',
            style: 'width:280px',
            sortable: true,
          },
          {
            name: 'policyFile',
            field: 'policyFile',
            label: '첨부파일',
            align: 'center',
            sortable: true,
            type: 'file',
            style: 'width: 250px',
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: '',
        startYear: '',
        endYear: '',
        startYmd: '',
        endYmd: '',
      },
      period: [],
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sai.shm.policy.list.url;
      // code setting
      // list setting 
      this.getList();
    },
    getList() {
      if (this.period) {
        this.searchParam.startYear = this.period[0];
        this.searchParam.endYear = this.period[1];
      } else {
        this.searchParam.startYear = '';
        this.searchParam.endYear = '';
      }
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.bookPopup(row);
    },
    bookPopup(result) {
      this.popupOptions.target = () => import(`${"./safHeaManagePolicyDetail.vue"}`);
      this.popupOptions.title = 'ESF 경영방침 상세'; 
      this.popupOptions.param = {
        policyId: result ? result.policyId : '',
      };
      this.popupOptions.isFull = true;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
